export default [
  {
    component: () => import("pages/advanced_search/AdvancedSearchView.vue"),
    meta: {
      title: "Advanced Search",
    },
    name: "advanced-search",
    path: "/advanced_search",
    props: (route) => ({
      query: route.query.query,
    }),
  },
  {
    component: () => import("pages/SearchArticle.vue"),
    meta: {
      title: "Search Articles",
    },
    name: "search-article",
    path: "/search",
    props: (route) => ({
      query: route.query.q,
    }),
  },
];
